module.exports = __webpack_public_path__ + "static/media/settings.1d261678.svg";